import { compact, concat, keyBy, map, omit, sortBy, uniq } from "lodash";
import { ADD_AVATARS, AvatarsActionTypes, AvatarsStateType, REMOVE_AVATARS } from "./types";
import { createReducer } from "@reduxjs/toolkit";
import { addAvatars, removeAvatar } from "./actions";
import avatar from "../../components/shared/avatar";

const initialState: AvatarsStateType = {
  avatars: {},
  roomAvatars: {},
};

//using redux
// export const avatarsReducer = (state = initialState, action: AvatarsActionTypes): AvatarsStateType => {
//   switch (action.type) {
//     case ADD_AVATARS: {
//       return {
//         ...state,
//         avatars: {
//           ...state.avatars,
//           ...keyBy(action.payload.avatars, "id"),
//         },
//         roomAvatars: {
//           ...state.roomAvatars,
//           [action.payload.roomId]: uniq(sortBy(compact(concat(state.roomAvatars[action.payload.roomId], map(action.payload.avatars, "id"))))),
//         },
//       };
//     }
//     case REMOVE_AVATARS: {
//       return {
//         ...state,
//         avatars: omit(state.avatars, action.payload.avatarId),
//         roomAvatars: {
//           ...state.roomAvatars,
//           [action.payload.roomId]: state.roomAvatars[action.payload.roomId]?.filter((avatarId) => avatarId !== action.payload.avatarId),
//         },
//       };
//     }
//     default: {
//       return state;
//     }
//   }
// };

//using redux toolkit
export const avatarsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(addAvatars, (state, action) => {
      state.avatars = {
        ...state.avatars,
        ...keyBy(action.payload.avatars, "id"),
      };
      state.roomAvatars[action.payload.roomId] = uniq(sortBy(compact(concat(state.roomAvatars[action.payload.roomId], map(action.payload.avatars, "id")))));
    })
    .addCase(removeAvatar, (state, action) => {
      state.avatars = omit(state.avatars, action.payload.avatarId);
      state.roomAvatars[action.payload.roomId] = state.roomAvatars[action.payload.roomId]?.filter((avatarId) => avatarId !== action.payload.avatarId);
    });
});
